import Vue from 'vue'
import VueRouter from 'vue-router'
import { requireComponent } from '@/utils'

Vue.use(VueRouter)

// 读取route
const routesList = []
function importAll (r) {
  r.keys().forEach(key => routesList.push(...r(key).default))
}
importAll(require.context(`./modules${process.env.VUE_APP_NODE_ENV === 'development' ? '' : '/' + process.env.VUE_APP_NODE_ENV}`, true, /\.js$/))

// 静态路由
export const constantRoutes = [
  {
    path: '/404',
    component: requireComponent('error-page/404.vue'),
    hidden: true
  }
  /* {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'Layout',
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          title: '首页',
          icon: 'home'
        },
        component: requireComponent('home')
      }
    ]
  } */
]

// 动态路由
export const asyncRoutes = routesList

const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRoutes
})

const router = createRouter()

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
